export default __webpack_public_path__ + "static/media/NoInternet.4458ad05.svg";